import { useEffect, useState } from 'react';

// TODO: recoilで実装する
const useAlertOnPageExit = (pathname: string) => {
  // 入力中にブラウザを閉じる場合はalertを表示
  // DefaultはOffにしておいて、useEffectでtrueに切り替える
  // OrganizationIDをクエパラに追加する処理でアラートが出るのを防ぐため
  const [confirmAlert, setConfirmAlert] = useState(false);

  useEffect(() => {
    setConfirmAlert(true);
  }, [pathname]);

  return { confirmAlert, setConfirmAlert };
};

export default useAlertOnPageExit;
